import { PhoneNumberForm } from "@/entities/phone-number-form";
import { usePhoneNumberForm } from "../../../model";

export const PhoneNumberStep = () => {
  const formProps = usePhoneNumberForm();

  return <PhoneNumberForm {...formProps} />;
};
